import { Modal } from '@surecompanies/core_components'

/**
 * Stakeholder-mandated warning shown everywhere Marqeta is selectable as a
 * VCN create provider (EMS-9720). WEX selection never shows this.
 */
export const confirmMarqetaProvider = (onConfirm: () => void): void => {
  Modal.confirm({
    title: 'Create Marqeta card?',
    content:
      'WEX is the standard provider. Only continue with Marqeta if the carrier does not accept WEX.',
    okText: 'Continue',
    cancelText: 'Cancel',
    onOk: onConfirm,
  })
}
